import { render, staticRenderFns } from "./WinLostModal.vue?vue&type=template&id=2ccc9f43&scoped=true&"
import script from "./WinLostModal.vue?vue&type=script&lang=js&"
export * from "./WinLostModal.vue?vue&type=script&lang=js&"
import style0 from "./WinLostModal.vue?vue&type=style&index=0&id=2ccc9f43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc9f43",
  null
  
)

export default component.exports